module.exports = __webpack_public_path__ + "assets/8a00f67430ec3b31d1e39f42866a6323.mp3";